const PlayButton = (): JSX.Element => (
  <>
    <circle cx="32" cy="32" r="30.9565" fill="none" stroke="currentColor" strokeWidth="2.08696" />
    <path d="M45.0896 32L23.6523 45.913V18.0869L45.0896 32Z" fill="currentColor" />
  </>
);

export default PlayButton;
